import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyApZuHLsFiYLMr5_AMzWKtL1Xeije4Ubro",
  authDomain: "push-notifications-f819d.firebaseapp.com",
  projectId: "push-notifications-f819d",
  storageBucket: "push-notifications-f819d.firebasestorage.app",
  messagingSenderId: "554548664455",
  appId: "1:554548664455:web:d132269d0771b7e1e90022",
  measurementId: "G-Y10RVPNP59",
};

const app = initializeApp(firebaseConfig);

const VAPID_KEY =
  "BNM79euFDtfpK5hVpUW6ZpXInq0dOKH7XNfb3T_QY6rDh_uY8AWbYtbY0SDYvUgEMx6NF11YjxX8O3X8-ajL4pQ";

let messaging = null;

const getFirebaseMessaging = async () => {
  try {
    const supported = await isSupported();

    if (!supported) {
      console.log(
        "Firebase Messaging is not supported in this environment."
      );
      return null;
    }

    if (typeof Notification === "undefined") {
      console.log(
        "Browser notifications are not supported."
      );
      return null;
    }

    if (!messaging) {
      messaging = getMessaging(app);
    }

    return messaging;
  } catch (error) {
    console.warn(
      "Firebase Messaging is unavailable:",
      error
    );

    return null;
  }
};

export const requestNotificationPermission = async () => {
  try {
    const messagingInstance = await getFirebaseMessaging();

    if (!messagingInstance) {
      return null;
    }

    const permission =
      await Notification.requestPermission();

    console.log(
      "Notification permission:",
      permission
    );

    if (permission !== "granted") {
      console.log(
        "Notification permission was not granted."
      );
      return null;
    }

    const token = await getToken(messagingInstance, {
      vapidKey: VAPID_KEY,
    });

    console.log("FCM TOKEN:", token);

    return token || null;
  } catch (error) {
    console.error(
      "Error getting notification permission/token:",
      error
    );

    return null;
  }
};

export const getCurrentNotificationToken = async () => {
  try {
    console.log(
      "Checking current notification permission..."
    );

    const messagingInstance = await getFirebaseMessaging();

    if (!messagingInstance) {
      return null;
    }

    if (Notification.permission !== "granted") {
      console.log(
        "Notification permission is not granted."
      );
      return null;
    }

    const token = await getToken(messagingInstance, {
      vapidKey: VAPID_KEY,
    });

    console.log(
      "Current FCM TOKEN:",
      token
    );

    return token || null;
  } catch (error) {
    console.error(
      "Error getting current FCM token:",
      error
    );

    return null;
  }
};

export const onMessageListener = async (callback) => {
  try {
    const messagingInstance = await getFirebaseMessaging();

    if (!messagingInstance) {
      return null;
    }

    return onMessage(messagingInstance, callback);
  } catch (error) {
    console.warn(
      "Firebase foreground messaging is unavailable:",
      error
    );

    return null;
  }
};

export default app;